"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledSystem = require("styled-system");

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _elevation = _interopRequireDefault(require("../../utils/elevation"));

var _excluded = ["leadingIcon", "trailingIcon", "allowOverFlow", "forceYMovement", "children", "disableYMovement", "color", "iconStyle"];
var buttonStyle = (0, _styledSystem.variant)({
  key: "buttons"
});

var justifyButtonText = function justifyButtonText(_ref) {
  var hideOverFlow = _ref.hideOverFlow,
      leadingIcon = _ref.leadingIcon,
      trailingIcon = _ref.trailingIcon;
  if (!hideOverFlow) return "space-around";
  if (leadingIcon && trailingIcon) return "center";
  if (leadingIcon) return "flex-end";
  if (trailingIcon) return "flex-start";
  return "space-around";
};

var StyledButton = _styledComponents["default"].button.withConfig({
  displayName: "Button__StyledButton",
  componentId: "sc-m12atk-0"
})(["", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " display:flex;text-transform:uppercase;align-items:center;justify-content:", ";transition:0.18s;", " &:hover{cursor:pointer;outline-width:0;transform:", ";box-shadow:", ";}&:focus{outline-width:0;}&:disabled{cursor:not-allowed;box-shadow:none !important;transform:", ";}"], _styledSystem.color, _styledSystem.width, _styledSystem.border, _styledSystem.borderRadius, _styledSystem.space, _styledSystem.height, buttonStyle, _styledSystem.fontSize, _styledSystem.fontWeight, _styledSystem.fontFamily, _elevation["default"], _styledSystem.maxWidth, _styledSystem.minWidth, _styledSystem.alignSelf, justifyButtonText, function (_ref2) {
  var allowOverFlow = _ref2.allowOverFlow;
  return allowOverFlow ? "" : "overflow: hidden; text-overflow: ellipsis; white-space: nowrap; position: relative;";
}, function (_ref3) {
  var elevation = _ref3.elevation,
      disabled = _ref3.disabled,
      forceYMovement = _ref3.forceYMovement,
      disableYMovement = _ref3.disableYMovement;

  if (disableYMovement) {
    return null;
  }

  if (disabled) {
    return null;
  }

  if (forceYMovement) {
    return "translateY(" + forceYMovement + "px)";
  }

  return "translateY(" + elevation / 2 + "px)";
}, function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled ? "inherit" : "none !important";
}, function (_ref5) {
  var elevation = _ref5.elevation,
      forceYMovement = _ref5.forceYMovement,
      disableYMovement = _ref5.disableYMovement;

  if (disableYMovement) {
    return null;
  }

  if (forceYMovement) {
    return "translateY(" + forceYMovement + "px)";
  }

  return "translateY(" + elevation / 2 + "px)";
});

StyledButton.propTypes = (0, _extends2["default"])({}, _styledSystem.fontFamily.propTypes, _styledSystem.color.propTypes, _styledSystem.width.propTypes, _styledSystem.space.propTypes, _styledSystem.border.propTypes, _styledSystem.borderRadius.propTypes, _styledSystem.height.propTypes, _styledSystem.fontSize.propTypes, {
  disabled: _propTypes["default"].bool
});
StyledButton.defaultProps = {
  fontFamily: "sansSerif",
  bg: "primary",
  width: "auto",
  borderRadius: 3,
  m: 0,
  border: "none",
  variant: null,
  height: 2,
  buttonStyle: "primary",
  fontSize: 3,
  elevation: 1,
  fontWeight: 700,
  px: 2,
  disabled: false
};
var ButtonIcon = (0, _styledComponents["default"])(_Icon["default"]).withConfig({
  displayName: "Button__ButtonIcon",
  componentId: "sc-m12atk-1"
})(["", " ", ";"], function (_ref6) {
  var overFlow = _ref6.overFlow;
  return overFlow ? "position: absolute;" : "";
}, function (_ref7) {
  var type = _ref7.type,
      overFlow = _ref7.overFlow;
  return overFlow && type === "leading" ? "left: 10px" : "right: 10px";
});

var Button = function Button(_ref8) {
  var leadingIcon = _ref8.leadingIcon,
      trailingIcon = _ref8.trailingIcon,
      allowOverFlow = _ref8.allowOverFlow,
      _ref8$forceYMovement = _ref8.forceYMovement,
      forceYMovement = _ref8$forceYMovement === void 0 ? 0 : _ref8$forceYMovement,
      children = _ref8.children,
      disableYMovement = _ref8.disableYMovement,
      buttonIconColor = _ref8.color,
      iconStyle = _ref8.iconStyle,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref8, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledButton, (0, _extends2["default"])({
    allowOverFlow: allowOverFlow,
    leadingIcon: leadingIcon,
    trailingIcon: trailingIcon,
    forceYMovement: forceYMovement,
    disableYMovement: disableYMovement,
    color: buttonIconColor
  }, props), leadingIcon && /*#__PURE__*/_react["default"].createElement(ButtonIcon, (0, _extends2["default"])({
    type: "leading",
    name: leadingIcon,
    color: buttonIconColor,
    mr: 2
  }, iconStyle)), children, trailingIcon && /*#__PURE__*/_react["default"].createElement(ButtonIcon, (0, _extends2["default"])({
    type: "trailing",
    name: trailingIcon,
    color: buttonIconColor,
    ml: 2
  }, iconStyle)));
};

Button.propTypes = (0, _extends2["default"])({}, StyledButton.propTypes, {
  leadingIcon: _propTypes["default"].string,
  trailingIcon: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element, _propTypes["default"].node]).isRequired
});
Button.defaultProps = {
  leadingIcon: null,
  trailingIcon: null
};
var _default = Button;
exports["default"] = _default;